export const docsPages = {
  'cache-configuration': {
    title: 'Cache configuration',
    description:
      'GraphCDN gives you fine-grained per-type or even per-field control over your cache behaviour for every single query that is sent through your service with cache rules.',
    notionId: '401627e2ff7e41da9cbc8b2b5dddcd1d',
  },
  'cache-purging': {
    title: 'Cache purging',
    description:
      "Invalidate cached query results by ID, type or query globally in 150ms with your app's Purging API.",
    notionId: 'c9b3e04d79554900ae57949373219d05',
  },
  scopes: {
    title: 'Scopes',
    description:
      'Define scopes to cache data separately for each user, whether they authenticate with headers or cookies.',
    notionId: '0f4aa72637da479ca623b4552f127646',
  },
  'key-fields': {
    title: 'Key fields',
    description:
      'Define which fields to use to uniquely identify certain nodes, which is necessary for the Purging API to be generated correctly.',
    notionId: '857dd2ad92464d60ab31e6354e3e14b5',
  },
  cli: {
    title: 'CLI',
    description:
      'Configure everything about your cache right from your codebase and push production schema changes with the GraphCDN CLI.',
    notionId: '7535bb1d75f049d898ca41b7e643e05a',
  },
  'graphcdn.yml': {
    title: 'graphcdn.yml',
    description: 'Reference for the graphcdn.yml config file.',
    notionId: '46b7b95693f64a3bb5d14da732154fe8',
  },
  production: {
    title: 'Production usage',
    description:
      'Start using GraphCDN to cache your GraphQL API for your users in production',
    notionId: '5fdb268e029c4cea853f0558b2dc4ae4',
  },
  environments: {
    title: 'Environments',
    description:
      'Your graphcdn.yml can define "environments", which is most useful to have different services for staging and production.',
    notionId: '095759714c084aad856a3a624cc14cd5',
  },
  limits: {
    title: 'Limits',
    description: 'The limits of GraphCDN.',
    notionId: 'cefc733530de4ffe9f77909a24f28a2d',
  },
}
